import { Box, styled } from '@mui/material';

export const StyledModalContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '90vw',
  maxHeight: '90vh',
  minWidth: '350px',
  paddingTop: theme.spacing(2),
}));
